import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceVendorId, EmployeeId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, employeeCalendarKeys, toast } from '@petseo/shared';

export const useDisconnectGoogleCalendar = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ serviceVendorId, employeeId }: { serviceVendorId: ServiceVendorId; employeeId: EmployeeId }) => {
      const response = await serviceVendorsClient.disconnectGoogleCalendarEndpoint(serviceVendorId, employeeId);
      return response.data;
    },
    onSuccess: (_, { serviceVendorId, employeeId }) => {
      queryClient.invalidateQueries({ queryKey: employeeCalendarKeys.forEmployee(serviceVendorId, employeeId) });
      toast.success(TOAST_MESSAGES.GOOGLE_CALENDAR_DISCONNECTED);
    },
    onError: () => {
      toast.error(TOAST_MESSAGES.GOOGLE_CALENDAR_DISCONNECT_ERROR);
    },
  });
};
